// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2FGCb","list":"styles_list__2bMof"};